module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAA/klEQVQ4T+2UYQ3CQBSDWwdIwAFIGA6QgANwAHOABCTggOEACaAAHJR0gXF7O5KN7CcvWZbc5b73ru1GjFwcmYfBQElzAFsAJclLHKgBSloCWGcmrkiWXn/B9gBWAA4ANhGaAn2wiEBJF5LzBLYk+ZA0AXCM0D7AyocAeLIa9m6ag/YFmtGCJdCpm5G0ZB9TJH27sie0XgVJa9fUzxNaW0mGNdBeGgI4ZVxevM2SZB1du5wh8crWwk+sK8lropmhzmInMhHorp3YALCrdtk6xnJ0bEiz19fluhlJv1sVzfwDs9+yg/2Tho7DLOPkLcndPbN/Ts0a/D/MAFtLowOf+RHCFWbfkK8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/scene/sceneicon.png
// module id = lRK2
// module chunks = 1